import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AdminOverlayComponent,
  DefaultOverlayComponent,
  SidebarLeftComponent,
  SidebarRightComponent
} from './components';
import { RouterModule } from '@angular/router';
import { AuthenticationModule } from '../authentication/authentication.module';
import { UserModule } from '../user/user.module';
import { LogoComponent } from './components/logo/logo.component';
import { AppResponsiveModule } from '@shared/libraries/ngx-responsive/responsive.module';
import { NavigationMobileComponent } from './components/navigation-mobile/navigation-mobile.component';
import { HeaderMobileComponent } from './components/header-mobile/header-mobile.component';
import { MenuVerticalComponent } from './components/menu/menu-vertical/menu-vertical.component';
import { MenuHorizontalComponent } from './components/menu/menu-horizontal/menu-horizontal.component';
import { RoleModule } from '@core/modules/role/role.module';
import { LogoSloganComponent } from './components/logo/logo-slogan.component';
import {
  MenuVerticalTreeComponent
} from './components/menu/menu-vertical/menu-vertical-tree/menu-vertical-tree.component';
import {
  MenuHorizontalSubmenuComponent
} from './components/menu/menu-horizontal/menu-horizontal-submenu/menu-horizontal-submenu.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { DefaultFullOverlayComponent } from '@core/modules/layout/components';
import { HintModule } from '@shared/modules/hint/hint.module';
import { SharedModule } from '@shared/shared.module';
import { LicenseModule } from '@core/modules/license/license.module';
import { VersionComponent } from '@core/components/version/version.component';

@NgModule({
  declarations: [
    DefaultOverlayComponent,
    AdminOverlayComponent,
    SidebarLeftComponent,
    SidebarRightComponent,
    LogoComponent,
    NavigationMobileComponent,
    HeaderMobileComponent,
    MenuVerticalComponent,
    MenuHorizontalComponent,
    LogoSloganComponent,
    MenuVerticalTreeComponent,
    MenuHorizontalSubmenuComponent,
    DefaultFullOverlayComponent
  ],
  exports: [
    DefaultOverlayComponent,
    AdminOverlayComponent,
    DefaultFullOverlayComponent,
    MenuVerticalComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    AuthenticationModule,
    RoleModule,
    UserModule,
    AppResponsiveModule,
    NgScrollbarModule,
    HintModule,
    SharedModule,
    LicenseModule,
    VersionComponent
  ]
})
export class LayoutModule {
}
